import AuthHelpers from "../helpers/AuthHelpers";
import ImportElement from "./ImportElement";

import { useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useData } from "@/stores/data";
import { validateOrToast } from "@/helpers/validateForm";

const schema = {
    fileInput: { required: true, label: "File" },
};

export default function Import() {
    const navigate = useNavigate();
    const {currentImport, setCurrentImport} = useData();
    const [fileName, setFileName] = useState("Upload");
    const [fileInput, setFileInput] = useState(null);
    const [uploading, setUploading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateOrToast({ fileInput }, schema)) return;
        setUploading(true);
        const toastLoading = toast.loading("Waiting...");
        const formData = new FormData();
        formData.append("file", fileInput);
        fetch(`${import.meta.env.VITE_API_BASE_URL}/api/import/${currentImport}`, {
            method: "POST",
            body: formData,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${AuthHelpers.auth_token()}`
            }
        })
            .then((res) => {
                if (res.status == 401) {
                    localStorage.removeItem("user");
                    navigate("/auth/login");
                    throw new Error("Unauthorized");
                }
                return res.json();
            })
            .then((res) => {
                setUploading(false);
                setCurrentImport("");
                if (res.success) {
                    toast.success(res.message, {
                        id: toastLoading
                    });
                } else {
                    toast.error(res.message, {
                        id: toastLoading
                    });
                }
            })
            .catch((_res) => {
                setUploading(false);
                setCurrentImport("");
                toast.error("Something Went Wrong", {
                    id: toastLoading
                });
            });
    };

    return (
        <div className="fixed top-0 left-0 flex z-[60] flex-col md:items-center bg-black bg-opacity-50 w-[100vw] h-[100vh] overflow-y-auto">
            <div className="bg-white p-[20px] rounded-[8px] m-[24px] max-w-[800px]">
                <h2 className="font-bold md:w-[500px] text-[24px] mb-[20px]">
                    Import <span className="capitalize">{currentImport.replaceAll("_", " ")}</span>
                </h2>
                <div className="flex flex-col gap-[24px]">
                    <ImportElement fileType={currentImport} />
                    <div>
                        <label htmlFor="import" className="purple-button cursor-pointer inline-block">{fileName}</label>
                        <input
                            type="file"
                            className="hidden"
                            id="import"
                            onChange={(e) => {
                                if (!e.target.files[0].name.includes(".csv")) {
                                    alert("Please upload a csv file");
                                    return;
                                }
                                const file = e.target.files[0];
                                setFileName(file.name);
                                setFileInput(file);
                            }}
                        />
                    </div>
                    <div className="flex justify-end items-center gap-[8px]">
                        <Button
                            variant="primary"
                            onClick={handleSubmit}
                            isLoading={uploading}
                        >
                            Submit
                        </Button>
                        <Button
                            variant="danger"
                            onClick={() => setCurrentImport("")}
                            isLoading={uploading}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
